const get = function({ url, header, data, success, error }) { // get方式请求数据
  let ajax = new XMLHttpRequest();

  if (data) {
    url += '?'
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const item = data[key]
        url += `&${key}=${item}`
      }
    }
  }

  ajax.open('get', url)

  ajax.setRequestHeader('content-type', 'application/x-www-form-urlencoded')
  if(header && typeof header === 'object'){
    Object.keys(header).map(key => {
      let value = header[key]
      ajax.setRequestHeader(key, value)
    })
  }

  ajax.send()

  ajax.onreadystatechange = () => {
    if (ajax.readyState == 4 && ajax.status == 200) {
      success && success(JSON.parse(ajax.responseText))
    }

    if (ajax.readyState == 4 && ajax.status == 500 && ajax.responseText) {
      // 返回错误信息
      let errMsg = JSON.parse(ajax.responseText)
      error && error(errMsg.message || `${url}请求错误`)
    } else if (ajax.readyState == 4 && ajax.status != 200) {
      error && error(`${url}请求错误`)
    }
  }
}

const post = function ({ url, data, success, error }) {
  console.log('send=====',data)
  let ajax = new XMLHttpRequest(), that = this;
  ajax.open('post', url)
  ajax.setRequestHeader('content-type', 'application/x-www-form-urlencoded')
  let sendData = ''
  if (data) {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const item = data[key]
        sendData += `&${key}=${item}`
      }
    }
  }
  ajax.send(sendData)

  ajax.onreadystatechange = () => {
    if (ajax.readyState == 4 && ajax.status == 200) {
      success && success(JSON.parse(ajax.responseText))
    }
    
    if (ajax.readyState == 4 && ajax.status == 500 && ajax.responseText) {
      // 返回错误信息
      let errMsg = JSON.parse(ajax.responseText)
      error && error(errMsg.message || `${url}请求错误`)
    }else if(ajax.readyState == 4 && ajax.status != 200){
      error && error(`${url}请求错误`)
    }
  }
}

export default {
  get,
  post
}